module.exports = __webpack_public_path__ + "img/gold3.08a66b31.png";